'use client';
import dynamic from 'next/dynamic';
import { PageLoading } from '@/app/Components/LoadingBubbles';
const MapPageClient = dynamic(() => import('./MapPageClient'), { ssr: false, loading: () => <PageLoading title="Bus tracker" description="Loading the interactive map." /> });
export default function MapPage() { return <MapPageClient />; }
